import {
  FETCH_PAPERBASE_HOMEWORK_SUCCESS,
  FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS,
} from './actions';
import { Map, List } from 'immutable';
import PaperBasedHomework from './model';

export default function paperBasedHomework(state = new Map(), action) {
  switch (action.type) {
    case FETCH_PAPERBASE_HOMEWORK_SUCCESS:
      return state.set(`${action.id}`, onSuccess(action.payload));
    case FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS:
      return onSuccess(action.payload).groupBy((paperBased) => paperBased.sessionId);
    default:
      return state;
  }
}

function onSuccess(paperBasedHomeworks) {
  return new List(paperBasedHomeworks.map((paperBased) => PaperBasedHomework.create(paperBased)));
}




// WEBPACK FOOTER //
// ./data/PaperBasedHomework/reducer.js